// This file is auto-generated by scripts/generate-version.js
// Do not edit manually

export const VERSION = '1.1.7.977d7d99';
export const SEMVER = '1.1.7';
export const GIT_SHA = '977d7d99';

export default VERSION;
